import React from 'react';
import styled, { css } from 'styled-components';
import { colors } from '../../style';
import { actionLight } from '../../style/theme-helpers';

export interface TableHeadProps extends React.ThHTMLAttributes<HTMLHeadingElement> {
  scope?: string;
  variant?: keyof typeof variants;
  sticky?: boolean;
}

const variants = {
  'border-bottom-gray300': css`
    background: white;
    /* box-shadow, not border-bottom, so the divider paints correctly when the thead is sticky. */
    & > tr > th,
    & > tr > td {
      box-shadow: inset 0 -1px 0 ${colors.gray300};
    }
  `,
  'action-light': css`
    background: ${actionLight};
  `,
  'light-blue': css`
    background: ${colors.lightBlue};
  `,
  'gray-100': css`
    background: ${colors.gray100};
  `,
  'gray-300': css`
    background: ${colors.gray300};
  `,
};

const StyledThead = styled.thead<{ variant: keyof typeof variants; sticky?: boolean }>`
  ${props => variants[props.variant]};

  height: 48px;

  ${props =>
    props.sticky &&
    css`
      position: sticky;
      z-index: 100;
      top: 0;
    `}
`;
export const TableHead: React.FC<TableHeadProps> = ({ sticky, variant = 'border-bottom-gray300', ...rest }) => (
  <StyledThead variant={variant} sticky={sticky} {...rest} />
);
